export const NOTIFICATION_STALE_TIME = 5 * 60 * 1000

export function shouldRefetchNotifications (lastFetchedAt?: number) {
  if (!lastFetchedAt) return true

  return Date.now() - lastFetchedAt > NOTIFICATION_STALE_TIME
}
